import { createStylesParams, StyleParamType } from '@wix/tpa-settings';
import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';

export type LayoutStylesParams = {
  sectionImageHeight: StyleParamType.Number;
  headerImageHeight: StyleParamType.Number;
  appHorizontalPadding: StyleParamType.Number;
  itemImageVerticalPadding: StyleParamType.Number;
  itemImageHorizontalPadding: StyleParamType.Number;
};

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  sectionImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
    metadata: {
      type: StyleType.number,
      defaultValue: { type: 'static', value: 320 },
      ai: { description: 'Height in pixels of the menu section image' },
    },
  },
  itemImageVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: { type: 'static', value: 0 },
      ai: {
        description:
          'Top and bottom padding in pixels around the item image in the card layout',
      },
    },
  },
  itemImageHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: { type: 'static', value: 0 },
      ai: {
        description:
          'Side padding in pixels around the item image in the card layout',
      },
    },
  },
  headerImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
    metadata: {
      type: StyleType.number,
      defaultValue: { type: 'static', value: 320 },
      ai: { description: 'Height in pixels of the menu header image' },
    },
  },
  appHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isMobile }) => (isMobile ? 0 : 24),
    metadata: {
      type: StyleType.number,
      defaultValue: { type: 'static', value: 24 },
      mobileDefaultValue: { type: 'static', value: 0 },
      ai: {
        description:
          'Horizontal padding in pixels on the left and right edges of the menu',
      },
    },
  },
});
